// Typed event bus singleton
// Define event payloads here
export interface EventMap {
  'wallet:updated': { newBalanceCents?: number } | undefined;
}

type Listener<E extends keyof EventMap> = (payload?: EventMap[E]) => void;

class EventBus {
  private listeners: Map<keyof EventMap, Set<Listener<any>>> = new Map();

  on<E extends keyof EventMap>(event: E, fn: Listener<E>) {
    if (!this.listeners.has(event)) this.listeners.set(event, new Set());
    this.listeners.get(event)!.add(fn as Listener<any>);
    return () => this.off(event, fn as Listener<any>);
  }

  off<E extends keyof EventMap>(event: E, fn: Listener<E>) {
    const set = this.listeners.get(event);
    if (!set) return;
    set.delete(fn as Listener<any>);
    if (set.size === 0) this.listeners.delete(event);
  }

  emit<E extends keyof EventMap>(event: E, payload?: EventMap[E]) {
    const set = this.listeners.get(event);
    if (!set) return;
    for (const fn of Array.from(set)) {
      try {
        (fn as Listener<E>)(payload);
      } catch (err) {
        // swallow errors to avoid breaking emitter
        // eslint-disable-next-line no-console
        console.error('eventBus listener error', err);
      }
    }
  }
}

const eventBus = new EventBus();
export default eventBus;
